import { z } from 'zod';

import type { TagSymbolMapping, TagSymbolMappings } from '../../../utilities';

const mappingSchema = z.object({
  from: z.string().min(1, 'From cannot be empty.'),
  to: z.string().min(1, 'To cannot be empty.'),
});

const categorySchema = z.union([z.array(mappingSchema), z.null()]).optional();

const tagSymbolMappingsSchema = z
  .object({
    skiptts: categorySchema,
    ttsOnly: categorySchema,
    lnk: categorySchema,
    red: categorySchema,
  })
  .strict();

export const getTagSymbolMappingFieldErrors = (
  item: Partial<TagSymbolMapping>
): Partial<Record<keyof TagSymbolMapping, string>> => {
  const result = mappingSchema.safeParse(item);
  if (result.success) return {};

  return Object.fromEntries(
    result.error.errors.map(err => [err.path[0], err.message])
  ) as Partial<Record<keyof TagSymbolMapping, string>>;
};

export const validateTagSymbolMappings = (
  value?: TagSymbolMappings | null
): string | false => {
  if (!value || Object.keys(value).length === 0) return false;

  const result = tagSymbolMappingsSchema.safeParse(value);
  if (result.success) return false;

  return result.error.errors
    .map(err => {
      const [category, index, field] = err.path;
      if (category !== undefined && index !== undefined && field !== undefined) {
        return `${category}[${Number(index) + 1}] (${field}): ${err.message}`;
      }
      return err.message;
    })
    .join(', ');
};
